export function BranchCustomersCtrl ($scope, $state, $translate, $uibModalInstance, sessionObjAPI, workshopAPI, messages) {
  $scope.company  = sessionObjAPI.company();
  $scope.searchInfo = "";
  $scope.searchParams = [
    {code: 'email', description: 'Email'},
    {code: 'mobile', description: 'Mobile'},
    {code: 'plate_number', description: 'Rego'},
    {code: 'vin', description: 'VIN'}
  ];

  $scope.filters = {
    search_term: '',
    search_type: 'email'
  }

  $scope.columnDefs = [
    {
      classes: 'text-left',
      field  : 'store_name',
      header : {
        text: 'Store Name'
      }
    },
    {
      classes: ['all-caps', 'text-left'],
      field  : 'first_name',
      header : {
        text: 'First Name'
      },
    },
    {
      classes: 'text-right',
      field  : 'last_name',
      header : {
        text: 'Last Name'
      }
    },
    {
      classes: 'text-right',
      field  : 'email',
      header : {
        text: 'Email'
      }
    }
  ];

  $scope.tableSettings = {
    columns: $scope.columnDefs,
    empty: {
      text: $translate.instant('GENERAL_SPACE.STATUS.NO_RESULTS')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowClick = function () {
    $scope.selectedRow = $scope.branchCustomers.find((row) => row.selected);
  };

  $scope.getBranchCustomers = function () {
    workshopAPI.post('/customers/branch_find', $scope.filters).then(function(customers) {
      $scope.branchCustomers = customers;
    })
  };

  $scope.addCustomer = function (row) {
    if (row.entity.vehicle_id) {
      workshopAPI.get('/customers/copy_from_branch', [row.entity.id, row.entity.vehicle_id]).then(function (customer) {
        messages.show('Customer Saved', 'success');
        $uibModalInstance.close();
      }, function (err) {
        messages.error(err);
      });
    } else {
      workshopAPI.get('/customers/copy_from_branch', row.entity.id).then(function (customer) {
        messages.show('Customer Saved', 'success');
        $uibModalInstance.close();
      }, function (err) {
        messages.error(err);
      });
    }
  };
}